import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_PREVIEW = `${REPORT}_SET_PREVIEW`;
export const RESET_PREVIEW = `${REPORT}_RESET_PREVIEW`;



// WEBPACK FOOTER //
// ./src/views/ReportPreview/flow/actionTypes.js